import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/site/Contact";

export const Route = createFileRoute("/contact")({
  component: () => <Contact />,
});
